import React from "react";

export default function LevelBadge({ level, progress = 0, need = 100, xp = 0, compact = false }) {
  const pct = Math.min(100, Math.round((progress / need) * 100));
  if (compact) {
    return (
      <div className="w-full" data-testid="level-badge">
        <div className="flex items-center justify-between text-xs mb-1.5">
          <span className="font-semibold text-emerald-400">Level {level}</span>
          <span className="text-white font-mono-stat">{progress}/{need} XP</span>
        </div>
        <div className="h-1.5 rounded-full bg-[#1c1c12] overflow-hidden">
          <div className="h-full rounded-full bg-gradient-to-r from-emerald-500 to-teal-400 transition-all duration-500" style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-4 p-4 rounded-2xl border border-[#242417] bg-[#12141C]" data-testid="level-badge">
      <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-400 flex items-center justify-center glow-emerald shrink-0">
        <span className="font-display text-2xl font-black text-black">{level}</span>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1.5">
          <span className="font-display font-bold">Level {level}</span>
          <span className="text-xs text-white font-mono-stat">{xp} XP total</span>
        </div>
        <div className="h-2 rounded-full bg-[#1c1c12] overflow-hidden">
          <div className="h-full rounded-full bg-gradient-to-r from-emerald-500 to-teal-400 transition-all duration-500" style={{ width: `${pct}%` }} />
        </div>
        <p className="text-xs text-white mt-1.5">{need - progress} XP to level {level + 1}</p>
      </div>
    </div>
  );
}
